<div class="flex items-center gap-1.5">
  <svg-icon [key]="icon()" class="max-h-[20px] max-w-[20px] text-text-light"></svg-icon>
  <h5 class="typo-h5-medium text-text-secondary">
    {{ displayText() | libPhoneFormat }}
  </h5>
</div>
